var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['prev-hover btn waves-effect waves-light', this.cssClass],attrs:{"type":_vm.type},on:{"mouseenter":_vm.mouseEnter,"mouseleave":_vm.mouseLeave,"click":_vm.clickEvt}},[_vm._v(" "+_vm._s(_vm.title)),_c('span',{staticClass:"bg"}),_c('span',{staticClass:"btn-tlt"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }